<c-container class="mt-5">
  <h2>Sent Emails</h2>
  <p>Every email we sent, or skipped sending, across all games. Click a row to see what was sent.</p>

  <form [formGroup]="filterFormGroup">
    <div class="flex-row-wrap justify-space-between">
      <mat-form-field appearance="outline" class="flex-50">
        <mat-label>Recipient</mat-label>
        <input type="text" formControlName="recipient" matInput placeholder="Email address, or its start"
               data-testid="sent-emails-recipient-input">
        <mat-hint>Matches addresses that start with this</mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline" class="flex-50">
        <mat-label>Game</mat-label>
        <mat-select placeholder="Any game" formControlName="game" data-testid="sent-emails-game-select">
          <mat-option [value]="null">Any game</mat-option>
          <mat-option [value]="noGame">No game (platform emails)</mat-option>
          @for (game of games; track game.Id) {
            <mat-option [value]="game.Id">{{ game.Name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="flex-50">
        <mat-label>Kind</mat-label>
        <mat-select placeholder="Any kind" formControlName="emailTemplateTypeId" data-testid="sent-emails-kind-select">
          <mat-option [value]="null">Any kind</mat-option>
          @for (type of emailTemplateTypes; track type.Value) {
            <mat-option [value]="type.Value">{{ type.Name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="flex-50">
        <mat-label>Status</mat-label>
        <mat-select placeholder="Any status" formControlName="status" data-testid="sent-emails-status-select">
          <mat-option [value]="null">Any status</mat-option>
          @for (status of statusOptions; track status.value) {
            <mat-option [value]="status.value">{{ status.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field class="flex-50" appearance="outline">
        <mat-label>Date Range</mat-label>
        <mat-date-range-input [rangePicker]="rangePicker">
          <input matStartDate placeholder="From" formControlName="fromDate" data-testid="sent-emails-from-date-input">
          <input matEndDate placeholder="To" formControlName="toDate" data-testid="sent-emails-to-date-input">
        </mat-date-range-input>
        <mat-hint>MM-DD-YYYY – MM-DD-YYYY</mat-hint>
        <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
        <mat-date-range-picker #rangePicker></mat-date-range-picker>
      </mat-form-field>
    </div>
  </form>

  <div class="text-end">
    <button mat-raised-button class="margin-right-small" color="primary" (click)="onFilterClick()"
            data-testid="sent-emails-filter-button">Filter</button>
    <button mat-raised-button (click)="onResetClick()" data-testid="sent-emails-reset-button">Reset</button>
  </div>

  @if (filter) {
    <app-email-audit-table [filter]="filter" [includeGameColumn]="true"></app-email-audit-table>
  }
</c-container>
